const tableTitleMap = {
  title: 'Mapa'
}

export default tableTitleMap;
